function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const admin_bar = document.querySelector("#_admin_bar");
	const page_url = new URL(
		`/misc/admin_tools/${admin_bar.dataset.ct}/${admin_bar.dataset.id}/`,
		window.location.origin,
	);
	const main_related = admin_bar.dataset.main_related;
	const main_related_ctype = admin_bar.dataset.main_related_ctype;
	if (main_related) {
		page_url.searchParams.append("mr", main_related);
	}
	if (main_related_ctype) {
		page_url.searchParams.append("mr_ct", main_related_ctype);
	}

	fetch(page_url.toString(), {
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		},
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.admin_bar) {
				admin_bar.outerHTML = data.admin_bar;
				document
					.querySelector("#_admin_bar_icon")
					.addEventListener("click", (e) => {
						e.preventDefault();
						e.stopImmediatePropagation();
						document.querySelector("#admin_bar").classList.toggle("d-none");
					});
			}
		})
		.catch((error) => {
			console.warn(error);
		});
});
